module.exports = __webpack_public_path__ + "static/solutions-91b56c5a57d0afa6cfdc34055397e012.png";